import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["operation"];
import quickFetch from 'quick-fetch';
import { stableStringify } from './internal/stableStringify';

// eslint-disable-next-line hubspot-dev/no-declarations

const makeGqlEarlyRequest = _ref => {
  let {
      operation
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const requestName = stableStringify({
    id: operation.query.id,
    operationName: operation.query.operationName,
    variables: operation.variables || {}
  });
  const data = {
    operationName: operation.query.operationName,
    query: operation.query.query
  };
  if (operation.variables) {
    data.variables = operation.variables;
  }
  quickFetch.makeEarlyRequest(requestName, Object.assign({}, rest, {
    type: 'POST',
    data: JSON.stringify(data),
    dataType: 'json',
    contentType: 'application/json'
  }));
};
const getGqlRequestName = ({
  operationName,
  variables,
  query
}) => {
  return stableStringify({
    operationName,
    variables: variables || {},
    id: query.id
  });
};
const getGqlEarlyRequestState = ({
  operationName,
  variables,
  query
}) => {
  // If the graphqlParse plugin is not enabled the `query` will not have an `id` property
  if (typeof __GRAPHQL_PARSE_PLUGIN__ === 'undefined' || __GRAPHQL_PARSE_PLUGIN__ === false) {
    return null;
  }
  const requestName = getGqlRequestName({
    operationName,
    variables,
    query
  });
  return quickFetch.getRequestStateByName(requestName);
};
const getGqlEarlyRequest = ({
  operationName,
  variables,
  query
}) => {
  // If the graphqlParse plugin is not enabled the `query` will not have an `id` property
  if (typeof __GRAPHQL_PARSE_PLUGIN__ === 'undefined' || __GRAPHQL_PARSE_PLUGIN__ === false) {
    return null;
  }
  const requestName = getGqlRequestName({
    operationName,
    variables,
    query
  });
  const requestState = quickFetch.getRequestStateByName(requestName);
  if (requestState && !requestState.error) {
    return new Promise((resolve, reject) => {
      requestState.whenFinished(response => {
        quickFetch.removeEarlyRequest(requestName);
        resolve(response);
      });
      requestState.onError((_, errorMessage) => {
        quickFetch.removeEarlyRequest(requestName);
        reject(errorMessage);
      });
    });
  }
  return null;
};
export { getGqlEarlyRequest, makeGqlEarlyRequest, getGqlEarlyRequestState };